import React, { useRef } from 'react';
import { useDetectOutsideClick } from '@hooks/useDetectOutsideClick';
import { AccountIconProps, NavigationOptions, OnClickProps } from '@types';
import { clearCookie } from '@utils/cookieHelper';
import { auth, config } from '../../config';
import { useSelector } from 'react-redux';
import { selectUserProfile } from '@store/selectors/widgets.selectors';
import MenuDropDown from '@components/customDropdown/MenuDropDown';
import { OptionLabel, OptionsWrapper } from '@components/MenuOptions/MenuOptions.styled';
import { RoundIconWrapper } from './Header.styled';

const RoundIcon = ({ userName, menuOptions }: AccountIconProps) => {
    const userProfile: NavigationOptions = useSelector(selectUserProfile);
    const initials = userName
        .match(/(\b\S)?/g)
        .join('')
        .match(/(^\S|\S$)?/g)
        .join('')
        .toUpperCase();
    const dropdownRef = useRef(null);
    const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);

    const toggleMenu = () => setIsActive(!isActive);

    const onClick = async ({ name }: OnClickProps) => {
        if (name === 'User Profile') {
            clearCookie();
            auth.getOkta().tokenManager.clear();
            window.location.replace(`${userProfile.url}?${window.btoa(config.env('redirectUri'))}`);
        }
    };
    document.getElementById('contentContainer')?.addEventListener('click', () => setIsActive(false));
    return (
        <OptionsWrapper isActive={isActive}>
            <OptionLabel onClick={toggleMenu} isActive={isActive} ref={dropdownRef}>
                <RoundIconWrapper id="accountIcon">
                    <div>{initials}</div>
                </RoundIconWrapper>
                <img
                    data-testid="dropdownimg"
                    src="https://dam.freedommortgage.com/dx/api/dam/v1/collections/e9810627-8508-4c5f-b7f1-91b83e5c5489/items/00c9b7f7-b9b7-4988-b218-a69dcf74e939/renditions/7a934cd5-c5da-43f4-892c-0045b1e37ec7?binary=true"
                    width={13}
                    height={13}
                />
            </OptionLabel>
            {isActive && <MenuDropDown options={menuOptions} onClick={onClick} />}
        </OptionsWrapper>
    );
};

export default React.memo(RoundIcon);
